import Vue from 'vue'
import marked from 'marked'

Vue.filter('googleDirection', function (address) {
    return 'https://google.com/maps/dir//' + address.replace(/\s\s+/g, ' ')
})

Vue.filter('addZero', function (number) {
    return (number.length > 1) ? number : '0' + number
})

Vue.filter('markdown', function (content) {
    let output = content

    // images
    output = output.replace(/!\[([a-zA-Z0-9 \-\/_.]*)[^\]]*\]\(([a-zA-Z0-9 \-\/_.]*)[^)]*\)/g, '<img src="$2" alt="$1">')

    // column break
    output = output.replace(/<!--column-break-->/g, '</div><div class="table-cell">')

    // youtube video
    output = output.replace(/<!--youtube:([A-Za-z0-9_\-]*)-->/g, '<div class="iframe-container"><iframe width="560" height="315" src="https://www.youtube.com/embed/$1?rel=0&amp;showinfo=0" frameborder="0" allowfullscreen></iframe></div>')

    // quote author
    output = output.replace(/<author>(.*?)<\/author>/g, '<span class="quote-author">$1</span>')

    return '<div class="table"><div class="table-cell md-column">' + marked(output) + '</div></div>'
})



// WEBPACK FOOTER //
// ./src/custom/filters.js